'use client';

import { useEffect } from 'react';
import { filterHubPagePathParam } from '@/utils/urlHelper';
import { queryStringConstants } from '@/constants/queryConstants';
import type { SearchParams } from '@/models/SearchParams';
import { usePathname, useSearchParams } from 'next/navigation';
import useAnalytics from '@/hooks/useAnalytics';

type Props = {
  searchParams: SearchParams;
};

export default function RefreshUrl({ searchParams }: Props): JSX.Element {
  const { filter } = searchParams;
  const analytics = useAnalytics();
  const pathName = usePathname();
  const urlFilters = useSearchParams();

  useEffect(() => {
    // Check hub page in url
    // If it is present and filter is not, then add specific filter to URL.
    // This will not reload/redirect the page, just add to URL
    const elements = pathName.split('/');
    const isHubPage = filterHubPagePathParam(elements);
    if (isHubPage && !urlFilters.get(queryStringConstants.FILTER)) {
      const currentUrl = new URL(window.location.href);
      const currentParams = new URLSearchParams(currentUrl.search);
      currentParams.set(queryStringConstants.FILTER, filter as string);
      currentUrl.search = currentParams.toString();
      window.history.pushState({}, '', currentUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [analytics, searchParams]);

  return <></>;
}
